import React from 'react';
import PropTypes from 'prop-types';
import cl from 'classnames';
import { Dropdown, Menu, Space } from 'antd';
import { Icon } from '@digitalc/dxp-ui';
import { HexToRGB, shouldShowImage, appUrlJump, formatPhoneSegment } from '@/utils/utils';
import moreImg from '@/assets/images/ic_home_more.svg';
import styles from '../../index.less';
import headerStyles from './index.less';

const NewToolbar = ({
  visible,
  pictures: _pictures,
  hasLogo,
  hasSidebar,
  showDivider,
  logoInfo,
  sidebarInfo,
  titleFontSize,
  titleFontColor,
  titleFontColorOpacity,
  isTitleFontBold,
  isTitleFontItalic,
  position,
  hasBackground,
  topMargin,
  bottomMargin,
  horizontalOutterMargin,
  topPadding,
  bottomPadding,
  horizontalInnerPadding,
  greetingsInfo,
  isTitleFontUnderline,
  accountSize,
  accountFontColor,
  accountFontColorOpacity,
  isAccountFontBold,
  isAccountFontItalic,
  isAccountFontUnderline,
  hasBack,
  backInfo,
  hasGrettings,
  hasAccount,
  accountInfo,
  bgStyle,
  fixedBgType, // bg的类型:Color | Image
  fixedBgImg,
  fixedBgColor,
  fixedBgOpacity,
  customBgList,
  eLoginTheme,
  isEmailLogin,
}) => {
  const localState = localStorage.getItem('currState');
  const settingState = localStorage.getItem('settingModal');
  const prevState = localStorage.getItem('currPrevState');
  const pictures = (_pictures || []).filter(it => it.visible !== false);
  const initAppStr = window.localStorage.getItem('initApp');
  const initApp = JSON.parse(initAppStr) || {};

  let iconsLength = pictures?.length > 3 ? 3 : pictures?.length;
  if (hasSidebar === 'Y') {
    iconsLength += 1;
  }
  if (hasBack === 'Y') {
    iconsLength += 1;
  }

  // 根据 bg 配置返回纯背景样式对象（颜色或图片），无配置时返回 null
  const resolveBgObj = () => {
    if (hasBackground !== 'Y') return null;
    if (bgStyle === 'fixed') {
      if (fixedBgType === 'Color') {
        return { backgroundColor: HexToRGB(fixedBgColor, fixedBgOpacity) };
      }
      return {
        backgroundImage: `url(${fixedBgImg?.src})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      };
    }
    const currentObj = customBgList?.[0] || {};
    if (currentObj.bgType === 'Color') {
      return { backgroundColor: HexToRGB(currentObj.color, currentObj.opacity) };
    }
    return {
      backgroundImage: `url(${currentObj.bgImg?.src})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    };
  };

  const getBgStyle = () => {
    const obj = resolveBgObj() || (hasBackground === 'Y' ? {} : { background: 'initial' });
    return {
      ...obj,
      marginTop: `${topMargin}px`,
      marginBottom: `${bottomMargin}px`,
      marginLeft: `${Number(horizontalOutterMargin || 0)}px`,
      marginRight: `${Number(horizontalOutterMargin || 0)}px`,
      paddingLeft: `${Number(horizontalInnerPadding || 0)}px`,
      paddingRight: `${Number(horizontalInnerPadding || 0)}px`,
      paddingTop: `${topPadding}px`,
      paddingBottom: `${bottomPadding}px`,
    };
  };

  const handleAppUrlJump = (url, schemaType = '') => {
    appUrlJump(url, Number(schemaType) === 1 || Number(schemaType) === 5);
  };
  const getMenu = () => (
    <Menu className={styles.toolbarMenu}>
      {(pictures.slice(0).splice(2) || []).map(item => (
        <Menu.Item key={item.src}>
          {shouldShowImage(item.src) && <img className={styles.toolbarImg} src={item.src} alt="" />}
          <span className={styles.name}>{item.iconName}</span>
        </Menu.Item>
      ))}
    </Menu>
  );

  // 键盘可达：图片放在 button 中，保证鼠标与键盘（Enter/Space）均可触发跳转
  const handleImgKeyDown = (info, e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    handleAppUrlJump(info?.link, info?.linkType);
  };

  const getImgWrap = (info, key, className) =>
    shouldShowImage(info?.src) && (
      <button
        type="button"
        key={key}
        className={className}
        onClick={() => handleAppUrlJump(info?.link, info?.linkType)}
        onKeyDown={e => handleImgKeyDown(info, e)}
        style={{
          border: 'none',
          background: 'transparent',
          padding: 0,
          cursor: 'pointer',
          height: `${info?.height / 2 || 24}px`,
          width: `${info?.width / 2 || 24}px`,
        }}
      >
        <img src={info?.src} alt={info?.iconName || ''} style={{ height: '100%', width: '100%' }} />
      </button>
    );

  const renderIcon = () => {
    // 如果pictures.length >= 5则全部放在...之中
    if (pictures.length > 3) {
      const lastestPicList = pictures.slice(0, 2);
      return (
        <div className={styles.innerMoreBox} style={{ marginLeft: '4px' }}>
          <div>{lastestPicList.map((item, index) => getImgWrap(item, index, styles.myIcon))}</div>
          <Dropdown overlay={getMenu()} trigger={['click']} placement="bottomRight">
            <button type="button" style={{ border: 'none', background: 'transparent', padding: 0, cursor: 'pointer' }}>
              <Space>
                {shouldShowImage(moreImg) && <img style={{ marginLeft: 4 }} src={moreImg} alt="" />}
              </Space>
            </button>
          </Dropdown>
        </div>
      );
    }
    return (
      <div className={styles.innerIconBox}>
        {(pictures || []).map((item, index) => getImgWrap(item, index, styles.myIcon))}
      </div>
    );
  };

  const titleStyle = {
    fontSize: `${titleFontSize}px`,
    color: HexToRGB(titleFontColor, titleFontColorOpacity),
    fontWeight: isTitleFontBold === 'Y' ? 'bold' : 'normal',
    fontStyle: isTitleFontItalic === 'Y' ? 'italic' : 'normal',
    textDecoration: isTitleFontUnderline === 'Y' ? 'underline' : '',
    display: 'flex',
    justifyContent: position,
    width: '100%',
    alignItems: 'center',
    lineHeight: 1.1,
    padding: '4px 0',
    wordBreak: 'break-word',
  };

  const accountStyle = {
    fontSize: `${accountSize}px`,
    color: HexToRGB(accountFontColor, accountFontColorOpacity),
    fontWeight: isAccountFontBold === 'Y' ? 'bold' : 'normal',
    fontStyle: isAccountFontItalic === 'Y' ? 'italic' : 'normal',
    textDecoration: isAccountFontUnderline === 'Y' ? 'underline' : '',
    display: 'flex',
    justifyContent: 'left',
    width: '100%',
    alignItems: 'center',
    lineHeight: 1,
  };

  const toolStyle = {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
  };

  const renderEmailLogin = () => {
    if (isEmailLogin) {
      return (
        <div
          className={headerStyles.emailLogin}
          style={{ color: eLoginTheme === 'white' ? '#fff' : '#222' }}
        >
          <Icon
            type="icon-Tack-1"
            style={{
              fontSize: '18px',
              marginRight: '4px',
              color: eLoginTheme === 'white' ? '#fff' : '#222',
            }}
          />
          <span className={headerStyles.content}>
            Managing multiple lines?{' '}
            <span
              className={headerStyles.loginWarp}
              style={{ color: eLoginTheme === 'white' ? '#E5FF17' : '#1800E7' }}
            >
              Log in
            </span>{' '}
            via email
          </span>
        </div>
      );
    }
    return null;
  };

  return (
    <div
      className={cl(
        { hidden: !visible },
        showDivider && headerStyles.showDivider,
        localState === '0' || prevState === 'Y' || settingState === 'Y' ? styles.previewBox : null,
      )}
    >
      <div style={getBgStyle()}>
        <div className={cl(styles.newToolbarInnerBox, styles.myNewToolbar)}>
          <div style={toolStyle}>
            <div
              className={styles.innerLeft}
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                flex: 1,
              }}
            >
              {hasBack === 'Y' && getImgWrap(backInfo?.[0])}
              {hasSidebar === 'Y' && getImgWrap(sidebarInfo?.[0])}
              {hasLogo === 'Y' && shouldShowImage(logoInfo?.[0]?.src) && (
                <img style={{ height: '24px' }} src={logoInfo?.[0]?.src} alt="" />
              )}
              {hasLogo !== 'Y' && iconsLength < 3 && isEmailLogin && renderEmailLogin()}
              {hasLogo !== 'Y' && iconsLength < 3 && !isEmailLogin && hasGrettings === 'Y' && (
                <div style={titleStyle}>{greetingsInfo?.fixedText}</div>
              )}
              {hasLogo !== 'Y' &&
                iconsLength <= 4 &&
                !isEmailLogin &&
                hasGrettings !== 'Y' &&
                hasAccount === 'Y' && (
                  <div style={accountStyle}>
                    {formatPhoneSegment(initApp.displayPhone || initApp.mobile)}
                    {shouldShowImage(accountInfo?.[0]?.src) && (
                      <img
                        style={{ height: '16px', marginLeft: '4px' }}
                        src={accountInfo?.[0]?.src}
                        alt=""
                      />
                    )}
                  </div>
              )}
            </div>
            <div className={styles.innerRight}>{renderIcon()}</div>
          </div>
        </div>
        {isEmailLogin &&
          (hasLogo === 'Y' || (hasLogo !== 'Y' && iconsLength >= 3)) &&
          renderEmailLogin()}
        {hasGrettings === 'Y' &&
          (hasLogo === 'Y' || (hasLogo !== 'Y' && iconsLength >= 3) || isEmailLogin) && (
            <div style={titleStyle}>{greetingsInfo?.fixedText}</div>
        )}
        {hasAccount === 'Y' &&
          (hasGrettings === 'Y' ||
            (hasLogo !== 'Y' && iconsLength > 4) ||
            hasLogo === 'Y' ||
            isEmailLogin) && (
            <div style={accountStyle}>
              {formatPhoneSegment(initApp.displayPhone || initApp.mobile)}
              {shouldShowImage(accountInfo?.[0]?.src) && (
                <img
                  style={{ height: '16px', marginLeft: '4px' }}
                  src={accountInfo?.[0]?.src}
                  alt=""
                />
              )}
            </div>
        )}
      </div>
    </div>
  );
};

// 图片信息项：{ src, iconName, link, linkType, width, height, visible }
const imageInfoPropTypes = PropTypes.shape({
  src: PropTypes.string,
  iconName: PropTypes.string,
  link: PropTypes.string,
  linkType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.number,
  height: PropTypes.number,
  visible: PropTypes.bool,
});

NewToolbar.propTypes = {
  visible: PropTypes.bool,
  pictures: PropTypes.arrayOf(imageInfoPropTypes),
  hasLogo: PropTypes.string,
  hasSidebar: PropTypes.string,
  showDivider: PropTypes.string,
  logoInfo: PropTypes.arrayOf(PropTypes.shape({ src: PropTypes.string })),
  sidebarInfo: PropTypes.arrayOf(imageInfoPropTypes),
  titleFontSize: PropTypes.number,
  titleFontColor: PropTypes.string,
  titleFontColorOpacity: PropTypes.number,
  isTitleFontBold: PropTypes.string,
  isTitleFontItalic: PropTypes.string,
  position: PropTypes.string,
  hasBackground: PropTypes.string,
  topMargin: PropTypes.number,
  bottomMargin: PropTypes.number,
  horizontalOutterMargin: PropTypes.number,
  topPadding: PropTypes.number,
  bottomPadding: PropTypes.number,
  horizontalInnerPadding: PropTypes.number,
  greetingsInfo: PropTypes.shape({ fixedText: PropTypes.string }),
  isTitleFontUnderline: PropTypes.string,
  accountSize: PropTypes.number,
  accountFontColor: PropTypes.string,
  accountFontColorOpacity: PropTypes.number,
  isAccountFontBold: PropTypes.string,
  isAccountFontItalic: PropTypes.string,
  isAccountFontUnderline: PropTypes.string,
  hasBack: PropTypes.string,
  backInfo: PropTypes.arrayOf(imageInfoPropTypes),
  hasGrettings: PropTypes.string,
  hasAccount: PropTypes.string,
  accountInfo: PropTypes.arrayOf(PropTypes.shape({ src: PropTypes.string })),
  bgStyle: PropTypes.string,
  fixedBgType: PropTypes.string,
  fixedBgImg: PropTypes.shape({ src: PropTypes.string }),
  fixedBgColor: PropTypes.string,
  fixedBgOpacity: PropTypes.number,
  customBgList: PropTypes.arrayOf(
    PropTypes.shape({
      bgType: PropTypes.string,
      color: PropTypes.string,
      opacity: PropTypes.number,
      bgImg: PropTypes.shape({ src: PropTypes.string }),
    }),
  ),
  eLoginTheme: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isEmailLogin: PropTypes.bool,
};

export default NewToolbar;
